import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * OperatorNumpad — bottom-sheet numeric keypad for tablet entry
 *
 * Props:
 *   label    {string}   Field label shown above the display
 *   value    {string}   Current string value (digits + optional decimal)
 *   onChange {fn}       Called with the new string value
 *   onConfirm {fn}      Called when operator taps "Listo"
 *   onCancel  {fn}      Called when operator taps "✕"
 */
const OperatorNumpad = ({ label, value, onChange, onConfirm, onCancel }) => {
  const { t } = useTranslation('operator');
  const handleKey = (key) => {
    if (key === 'C') {
      onChange('');
      return;
    }
    if (key === '⌫') {
      onChange(value.slice(0, -1));
      return;
    }
    if (key === '.') {
      if (value.includes('.')) return; // only one decimal
      onChange(value === '' ? '0.' : value + '.');
      return;
    }
    // Digit
    if (value === '0' && key !== '.') {
      onChange(key);
      return;
    }
    // Limit to reasonable precision
    const parts = value.split('.');
    if (parts[1] !== undefined && parts[1].length >= 3) return;
    onChange(value + key);
  };

  const keys = ['7', '8', '9', '4', '5', '6', '1', '2', '3', 'C', '0', '.'];

  return (
    <div className="op-numpad-overlay" onClick={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="op-numpad-sheet">
        {label && <div className="op-numpad-field-label">{label}</div>}
        <div className={`op-numpad-display${!value ? ' empty' : ''}`}>
          {value || '0'}
        </div>
        <div className="op-numpad-grid">
          {keys.map((k) => (
            <button
              key={k}
              className={`op-numpad-key${k === 'C' || k === '⌫' ? ' key-action' : ''}`}
              onClick={() => handleKey(k)}
            >
              {k}
            </button>
          ))}
          <button
            className="op-numpad-key key-action"
            onClick={() => handleKey('⌫')}
          >
            ⌫
          </button>
          <button
            className="op-numpad-key key-confirm"
            style={{ gridColumn: 'span 2' }}
            onClick={onConfirm}
          >
            {t('operatorNumpad.done')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OperatorNumpad;
